import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
import { CtaButton } from './CtaButton';
const bullets = ['Hacer el Encuadre de cada sujeto obligado individualmente — sin un criterio sistematizado, volviendo a la norma cada vez que aparece un caso que no es tan obvio', 'Redactar una Notificación distinta para el director de la SA, otra para el gerente de la SRL y otra para el abogado que cobra honorarios judiciales — misma norma, mensajes completamente distintos', 'Resolver los plazos diferenciados por sector — aseguradoras desde septiembre, bancos desde octubre, tarjetas y procesadoras hasta diciembre — sin un cronograma visible se convierte en un Excel que hacés vos desde cero', 'Los sujetos obligados que ya se enteraron algo y te llaman o te mandan WhatsApp preguntando si tienen que hacer algo — y vos respondiendo lo mismo diez veces fuera de horario', 'Notificar fuera de término porque llegaste a septiembre con el Encuadre pendiente y las aseguradoras ya en el primer vencimiento'];
export function ProblemAgitation() {
  return <section className="w-full bg-alt" data-id="element-206" data-mp="a54a5shd6rhn">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-20" data-id="element-207" data-mp="a65l7wydrdzd">
        <SectionReveal data-id="element-208" data-mp="nw93kcu52njj">
          <h2 className="text-2xl font-black leading-tight text-ink sm:text-3xl md:text-4xl" data-id="element-209" data-mp="nwskbq81z5vz">
            Ya leíste la resolución.
            <br data-id="element-210" data-mp="j3fzzsaepl91" />
            <span className="text-accent" data-id="element-211" data-mp="xtwzv77e833t">
              Ahora viene la parte que nadie quiere hacer.
            </span>
          </h2>

          <p className="mt-5 text-base leading-relaxed text-ink-soft" data-id="element-212" data-mp="su0xtdi9alqw">
            Sabés que desde julio hay nuevos sujetos obligados a emitir
            comprobantes electrónicos. Directores de SA, gerentes de SRL,
            abogados por honorarios judiciales, colegios privados, prepagas. Lo
            tenés claro.
          </p>
          <p className="mt-4 text-base leading-relaxed text-ink-soft" data-id="element-213" data-mp="38oay0wd4o7m4">
            Lo que todavía no tenés claro es cómo vas a resolver el Encuadre de
            todos los sujetos obligados sin dedicarle dos días de trabajo
            administrativo que no te paga nadie.
          </p>
        </SectionReveal>

        <ul className="mt-8 space-y-4" data-id="element-214" data-mp="1ckwoefb7sogy">
          {bullets.map((text, i) => <SectionReveal key={i} delay={i * 0.06} data-id="element-215" data-mp="1hk9d75lnc5m6" data-mpi={i}>
              <li className="flex items-start gap-3 rounded-xl bg-base p-4 shadow-sm" data-id="element-216" data-mp="1mhja16bd7jk1">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent/10" data-id="element-217" data-mp="1qjecie5182ze">
                  <XIcon className="h-4 w-4 text-accent" strokeWidth={2.6} data-id="element-218" data-mp="1vgwbpct8z3u7" />
                </span>
                <span className="text-[15px] leading-relaxed text-ink" data-id="element-219" data-mp="209pgg0opuc6a">
                  {text}
                </span>
              </li>
            </SectionReveal>)}
        </ul>

        <SectionReveal delay={0.1} data-id="element-220" data-mp="2a7n34jqxg0ws">
          <div className="mt-8 rounded-r-xl border-l-4 border-accent bg-base p-5 shadow-sm" data-id="element-221" data-mp="2a8oqnnp4qfve">
            <p className="text-lg font-bold leading-snug text-ink" data-id="element-222" data-mp="2e8yy74sklecd">
              No es que no sepas qué hacer. Es que hacerlo a mano, sujeto
              obligado por sujeto obligado, son horas que no tenés.
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.15} data-id="element-223" data-mp="3pp05a335f2yk">
          <div className="mt-8 text-center" data-id="element-224" data-mp="3pq1t7859jjxp">
            <CtaButton className="w-full sm:w-auto" data-id="element-225" data-mp="3kr8cz7yldetu">
              → QUIERO MI ESTUDIOPACK — $27.990 ARS
            </CtaButton>
          </div>
        </SectionReveal>
      </div>
    </section>;
}